import { useEffect, useState } from "react";

import { useQuery } from "@apollo/client/react";
import { isToday } from "date-fns";
import { Toast } from "react-bootstrap";

import { DoneButton } from "@/containers/buttons";
import { CurrentEmployeeCouponDocument } from "@/gql/graphql";
import { formatCurrency } from "@/number_format";
import { parsedDate } from "@/utils/dates";

export default function CouponBonus() {
  const [isVisible, setIsVisible] = useState(false);

  const { data } = useQuery(CurrentEmployeeCouponDocument);

  useEffect(() => {
    if (!data?.currentEmployeeCoupon) return;

    const date = localStorage.getItem(`coupon-bonus-${data.currentEmployeeCoupon.id}`);
    const parsed = date ? parsedDate(date) : null;
    const seenToday = parsed ? isToday(parsed) : false;

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsVisible(!!data.currentEmployeeCoupon.amount && !seenToday);
  }, [data]);

  const currentCoupon = data?.currentEmployeeCoupon;

  if (!currentCoupon || currentCoupon === null) {
    return null;
  }

  async function hide() {
    setIsVisible(false);
    if (currentCoupon) {
      localStorage.setItem(`coupon-bonus-${currentCoupon.id}`, JSON.stringify(new Date()));
    }
  }

  return (
    <Toast className="TT-coupon-toast" show={isVisible} onClose={hide}>
      <Toast.Header closeButton>
        <span className="me-auto">Gutschein verfügbar!</span>
      </Toast.Header>

      <Toast.Body>
        <h4>Vielen herzlichen Dank für Ihre herausragende Arbeit!</h4>
        <p>
          Wir möchten uns auf besondere Weise bei Ihnen bedanken und haben einen Sachgutschein über{" "}
          {formatCurrency(currentCoupon.amount)} für Sie vorbereitet.
        </p>

        <DoneButton onClick={hide} size="sm">
          alles klar!
        </DoneButton>
      </Toast.Body>
    </Toast>
  );
}
